import React from 'react';
import TemplateSettings from './TemplateSettings';
import TemplateFieldEditor from './TemplateFieldEditor';
import TemplatePreview from './TemplatePreview';

const EditorModal = ({
  editingTemplate,
  editingFields,
  saving,
  previewLoading,
  expandedFields,
  selectedFieldId,
  showVariables,

  // Actions
  saveTemplate,
  closeEditor,
  previewTemplateHandler,

  // Global settings
  updateGlobalSetting,
  resetAllFontsToGlobal,

  // Field management
  addField,
  updateField,
  removeField,
  addContentLine,
  updateContentLine,
  removeContentLine,
  toggleLineBold,

  // Variables
  toggleVariablesPanel,
  insertVariable,
  insertVariableNewLine,

  // Field expansion
  toggleFieldExpansion,
  selectField,
  expandAllFields,
  collapseAllFields,

  // Field reordering
  moveFieldUp,
  moveFieldDown,
  moveFieldToPosition,

  // Column reordering
  moveColumnUp,
  moveColumnDown,
}) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
  }}>
    {/* Top bar */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 20px',
      backgroundColor: 'var(--card-bg)',
      borderBottom: '1px solid var(--border)',
      flexShrink: 0,
    }}>
      <h3 style={{ margin: 0, fontSize: '16px', color: 'var(--text)' }}>
        Edycja szablonu: {editingTemplate.name}
      </h3>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <button
          onClick={() => previewTemplateHandler({
            ...editingTemplate,
            config: { ...editingTemplate.config, fields: editingFields }
          })}
          disabled={previewLoading}
          style={{
            backgroundColor: previewLoading ? 'var(--text-muted)' : 'var(--info)',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            cursor: previewLoading ? 'not-allowed' : 'pointer',
            fontSize: '12px',
          }}
        >
          {previewLoading ? 'Generowanie...' : 'Podglad PDF'}
        </button>
        <button
          onClick={saveTemplate}
          disabled={saving}
          className="btn btn-success"
          style={{ padding: '6px 12px', fontSize: '12px' }}
        >
          {saving ? 'Zapisywanie...' : 'Zapisz'}
        </button>
        <button
          onClick={closeEditor}
          style={{
            border: '1px solid var(--border)',
            color: 'var(--text-muted)',
            backgroundColor: 'transparent',
            padding: '6px 12px',
            cursor: 'pointer',
            fontSize: '12px',
          }}
        >
          Zamknij
        </button>
      </div>
    </div>

    {/* Global settings bar */}
    <div style={{
      padding: '8px 20px',
      backgroundColor: 'var(--bg)',
      borderBottom: '1px solid var(--border)',
      flexShrink: 0,
    }}>
      <TemplateSettings
        editingTemplate={editingTemplate}
        updateGlobalSetting={updateGlobalSetting}
        resetAllFontsToGlobal={resetAllFontsToGlobal}
      />
    </div>

    {/* Main content: 40% fields | 60% preview */}
    <div style={{
      display: 'flex',
      flex: 1,
      overflow: 'hidden',
    }}>
      {/* Left panel - Fields (40%) */}
      <div style={{
        width: '40%',
        minWidth: '350px',
        maxWidth: '500px',
        overflow: 'auto',
        padding: '15px',
        backgroundColor: 'var(--card-bg)',
        borderRight: '1px solid var(--border)',
      }}>
        <TemplateFieldEditor
          editingFields={editingFields}
          expandedFields={expandedFields}
          selectedFieldId={selectedFieldId}
          showVariables={showVariables}
          addField={addField}
          updateField={updateField}
          removeField={removeField}
          addContentLine={addContentLine}
          updateContentLine={updateContentLine}
          removeContentLine={removeContentLine}
          toggleLineBold={toggleLineBold}
          toggleVariablesPanel={toggleVariablesPanel}
          insertVariable={insertVariable}
          insertVariableNewLine={insertVariableNewLine}
          toggleFieldExpansion={toggleFieldExpansion}
          expandAllFields={expandAllFields}
          collapseAllFields={collapseAllFields}
          moveFieldUp={moveFieldUp}
          moveFieldDown={moveFieldDown}
          moveFieldToPosition={moveFieldToPosition}
          moveColumnUp={moveColumnUp}
          moveColumnDown={moveColumnDown}
        />
      </div>

      {/* Right panel - Preview (60%) */}
      <div style={{
        flex: 1,
        overflow: 'hidden',
        padding: '15px',
        backgroundColor: '#f3f4f6',
        display: 'flex',
      }}>
        <TemplatePreview
          editingFields={editingFields}
          selectedFieldId={selectedFieldId}
          selectField={selectField}
          updateField={updateField}
        />
      </div>
    </div>
  </div>
);

export default EditorModal;
